import { Box } from "@mui/material";
import queryString from "query-string";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";

import APP_ROUTES from "../../../../routers/routeConstants";

import GinoHeader from "../../components/GinoHeader";
import { useGetGinoCredits } from "../../api/queries/ginoCredits";
import { UserCard, UserLoadingCard } from "../../components/UserCard";

import { useInfiniteSearchUsers } from "../../../User/api/queries/useInfiniteSearchUsers";

const GinoResults = () => {
  const { search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!search) navigate(APP_ROUTES.GINO);
  }, [search]);
  const parsedParams = queryString.parse(search, { arrayFormat: "comma" });

  const { ref, inView } = useInView({
    threshold: 0.5,
  });

  const {
    data: searchResults,
    isLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    isError,
  } = useInfiniteSearchUsers(parsedParams);

  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, isFetchingNextPage, fetchNextPage]);

  const users = searchResults ?? [];

  const { data: ginoCredits, isLoading: isLoadingGinoCredits, error: errorGinoCredits } = useGetGinoCredits();

  const [openCreditLeftModal, setOpenCreditLeftModal] = useState(false);
  const handleOpenCreditLeftModal = () => setOpenCreditLeftModal(true);
  const handleCloseCreditLeftModal = () => setOpenCreditLeftModal(false);

  return (
    <Box sx={styles.container}>
      <GinoHeader
        ginoCredits={ginoCredits}
        isLoadingGinoCredits={isLoadingGinoCredits}
        errorGinoCredits={errorGinoCredits}
        openCreditLeftModal={openCreditLeftModal}
        handleOpenCreditLeftModal={handleOpenCreditLeftModal}
        handleCloseCreditLeftModal={handleCloseCreditLeftModal}
      />
      <Box sx={styles.resultsContainer}>
        {users.map((user) => (
          <UserCard key={user.id} user={user} flexible={false} />
        ))}
        {isLoading && Array.from({ length: 12 }).map((_, index) => <UserLoadingCard key={index} flexible={false} />)}
        {isFetchingNextPage &&
          Array.from({ length: 3 }).map((_, index) => <UserLoadingCard key={index} flexible={false} />)}
        <Box ref={ref} sx={{ width: "100%", height: "20px" }} />
      </Box>
    </Box>
  );
};

export default GinoResults;

const styles = {
  container: {
    width: "100%",
    background: "var(--background-surface-default, #FFF)",
    padding: { xs: "16px", md: "32px" },
    display: "flex",
    flexDirection: "column",
    gap: "32px",
  },
  resultsContainer: {
    display: "grid",
    gridTemplateColumns: { xs: "repeat(1, 1fr)", sm: "repeat(2, 1fr)", md: "repeat(4, 1fr)", lg: "repeat(3, 1fr)" },
    gap: "16px",
  },
};
